import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

// Custom Plasma theme extending Material Design
export const PlasmaTheme = definePreset(Material, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    colorScheme: {
      light: {
        primary: {
          color: '#005de7',
          contrastColor: '#ffffff',
          hoverColor: '#084fc5',
          activeColor: '#0d469b'
        },
        surface: {
          0: '#ffffff',
          50: '#f3f8fb',
          100: '#e4edf5',
          200: '#cfe0ee',
          300: '#aecce2',
          400: '#87b0d3',
          500: '#6a95c7',
          600: '#567eb9',
          700: '#4c6ca9',
          800: '#425a8b',
          900: '#394c6f',
          950: '#263045'
        }
      }
    }
  },
  primitive: {
    blue: {
      50: '#edf9ff',
      100: '#d6efff',
      200: '#b5e4ff',
      300: '#83d5ff',
      400: '#48bdff',
      500: '#1e9bff',
      600: '#067bff',
      700: '#005de7',
      800: '#084fc5',
      900: '#0d469b',
      950: '#0e2b5d'
    },
    green: {
      50: '#ebfef6',
      100: '#d0fbe8',
      200: '#a4f6d6',
      300: '#6aebc1',
      400: '#2fd8a6',
      500: '#0abf90',
      600: '#009e78',
      700: '#007c62',
      800: '#03624e',
      900: '#045041',
      950: '#012d26'
    },
    red: {
      50: '#fff1f0',
      100: '#ffe0de',
      200: '#ffc7c2',
      300: '#ffa098',
      400: '#ff3a2a',
      500: '#ff3a2a',
      600: '#e91807',
      700: '#d11304',
      800: '#ac1408',
      900: '#8e180e',
      950: '#4e0701'
    },
    orange: {
      50: '#fff8eb',
      100: '#ffecc6',
      200: '#ffd788',
      300: '#ffbd4a',
      400: '#ffa82d',
      500: '#f97e07',
      600: '#dd5902',
      700: '#b73b06',
      800: '#942d0c',
      900: '#7a250d',
      950: '#461102'
    },
    gray: {
      50: '#f3f8fb',
      100: '#e4edf5',
      200: '#cfe0ee',
      300: '#aecce2',
      400: '#87b0d3',
      500: '#6a95c7',
      600: '#567eb9',
      700: '#4c6ca9',
      800: '#425a8b',
      900: '#394c6f',
      950: '#263045'
    }
  }
});
